import { useEffect, useRef } from 'react'
import { log } from 'services/logs/api'

function useLogFirstClick(route, extraContext = {}) {
  const firstClickLoggedRef = useRef(false)
  const routeRef = useRef(route)
  const extraContextRef = useRef(extraContext)

  useEffect(() => {
    routeRef.current = route
    extraContextRef.current = extraContext
  }, [route, extraContext])

  useEffect(() => {
    function handleFirstClick(event) {
      if (!firstClickLoggedRef.current && !sessionStorage.getItem('firstClickLogged')) {
        firstClickLoggedRef.current = true
        sessionStorage.setItem('firstClickLogged', 'true')

        const clickedTag = event.target.tagName
        const clickedText = event.target.innerText?.slice(0, 100)

        let sectionTitle = ''
        let cardTitleNode = event.target.closest && event.target.closest('.card-title')
        if (!cardTitleNode) {
          const cardBody = event.target.closest && event.target.closest('.card-body')
          if (cardBody) {
            cardTitleNode = cardBody.querySelector('.card-title')
          }
        }
        if (cardTitleNode) {
          sectionTitle = cardTitleNode.textContent.trim()
        } else {
          let node = event.target
          while (node && node !== document.body) {
            if (node.querySelector && node.querySelector('h3')) {
              sectionTitle = node.querySelector('h3').innerText
              break
            }
            if (node.classList && node.classList.contains('panel-heading')) {
              sectionTitle = node.innerText
              break
            }
            node = node.parentElement
          }
        }

        log({
          EventName: 'FirstClick',
          tag: clickedTag,
          text: clickedText,
          section: sectionTitle,
          classList: event.target.className,
          route: routeRef.current,
          timestamp: new Date().toISOString(),
          ...extraContextRef.current,
        })

        window.removeEventListener('click', handleFirstClick, true)
      }
    }

    if (!sessionStorage.getItem('firstClickLogged')) {
      window.addEventListener('click', handleFirstClick, true)
    }
    return () => window.removeEventListener('click', handleFirstClick, true)
  }, [])
}

export default useLogFirstClick
